import React from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import RouterAnchorLinkButton from "components/buttons/RouterAnchorLinkButton";
import routes from "routes";
import packshotImage from "assets/images/homePage/bannerSection/img_packshot_all.png";
import SkewedSection from "components/SkewedSection";
import { darkTextBoxBackgroundColour } from "theme";
import { StyledButtonSize } from "components/buttons/StyledButton";

const useStyles = makeStyles((theme: Theme) => {
    const packshotImageZIndex = 100;

    return createStyles({
        root: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        image: {
            zIndex: packshotImageZIndex,
            maxWidth: "45%",
            "& img": {
                width: "100%",
                maxWidth: 250,
                minWidth: 125,
            },
        },
        buttonContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: darkTextBoxBackgroundColour,
            marginLeft: -5,
            zIndex: packshotImageZIndex - 1,
        },
        button: {
            margin: theme.spacing(1),
        },
    });
});

interface IProps {}

export default function BuyNowWidget(props: IProps) {
    const classes = useStyles();

    const theme = useTheme();
    const xxsScreen = useMediaQuery("@media (max-width:420px)");
    const xsScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const smScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const smMdScreen = useMediaQuery("@media (max-width:1000px)");
    const mdScreen = useMediaQuery(theme.breakpoints.down("md"));

    const getButtonSize = (): StyledButtonSize => {
        if (xxsScreen) return "small";
        if (xsScreen) return "large";
        if (smScreen) return "extralarge";
        if (smMdScreen) return "medium";
        if (mdScreen) return "large";

        return "extralarge";
    };

    return (
        <div className={classes.root}>
            <div className={classes.image}>
                <img src={packshotImage} alt="Packshot" />
            </div>
            <SkewedSection axis="x" skewAmount={-5} className={classes.buttonContainer}>
                <RouterAnchorLinkButton
                    className={classes.button}
                    size={getButtonSize()}
                    route={routes.home.route}
                    anchor={routes.home.anchors.buy}
                >
                    Buy Now
                </RouterAnchorLinkButton>
            </SkewedSection>
        </div>
    );
}
